function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var p = "modulepreload",
  v = function v(l) {
    return "/" + l;
  },
  u = {},
  y = function y(d, c, E) {
    var i = Promise.resolve();
    if (c && c.length > 0) {
      var f = function f(e) {
        return Promise.all(e.map(function (o) {
          return Promise.resolve(o).then(function (s) {
            return {
              status: "fulfilled",
              value: s
            };
          }, function (s) {
            return {
              status: "rejected",
              reason: s
            };
          });
        }));
      };
      document.getElementsByTagName("link");
      var r = document.querySelector("meta[property=csp-nonce]"),
        t = (r === null || r === void 0 ? void 0 : r.nonce) || (r === null || r === void 0 ? void 0 : r.getAttribute("nonce"));
      i = f(c.map(function (e) {
        if (e = v(e), e in u) return;
        u[e] = !0;
        var o = e.endsWith(".css"),
          s = o ? '[rel="stylesheet"]' : "";
        if (document.querySelector("link[href=\"".concat(e, "\"]").concat(s))) return;
        var n = document.createElement("link");
        if (n.rel = o ? "stylesheet" : p, o || (n.as = "script"), n.crossOrigin = "", n.href = e, t && n.setAttribute("nonce", t), document.head.appendChild(n), o) return new Promise(function (m, h) {
          n.addEventListener("load", m), n.addEventListener("error", function () {
            return h(new Error("Unable to preload CSS for ".concat(e)));
          });
        });
      }));
    }
    function a(r) {
      var t = new Event("vite:preloadError", {
        cancelable: !0
      });
      if (t.payload = r, window.dispatchEvent(t), !t.defaultPrevented) throw r;
    }
    return i.then(function (r) {
      var _iterator = _createForOfIteratorHelper(r || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          _t.status === "rejected" && a(_t.reason);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return d().catch(a);
    });
  };
export { y as __vitePreload };